module.exports = __webpack_public_path__ + "img/footer.00cf8b9.png";